export const PHOTO_BUTTON = ".js-gallery-photo-button"
export const PHOTO_BUTTON_DISABLED = "gallery-photo__button--is-disabled"
export const PHOTO_BUTTON_HIDDEN = "gallery-photo__button--is-hidden"

export const PHOTO_LOADER = ".js-gallery-photo-loader"
export const PHOTO = ".js-gallery-photo"
export const PHOTO_CONTAINER = ".js-gallery-photo-container"
export const PHOTO_IMAGE = ".js-gallery-photo-image"
export const PHOTO_TITLE = ".js-gallery-photo-title"

export const PHOTO_AUTHOR = ".js-gallery-photo-user-container"
export const PHOTO_AUTHOR_LINK = ".js-gallery-photo-user"
export const PHOTO_AUTHOR_NAME = ".js-gallery-photo-author"
export const PHOTO_AUTHOR_PHOTOS_NUM = ".js-gallery-photo-user-num-photos"

export const PHOTO_TIME = ".js-gallery-photo-time-container"
export const PHOTO_TIME_NUM = ".js-gallery-photo-taken-at"

export const PHOTO_RATING = ".js-gallery-photo-rating"
export const PHOTO_RATING_NUM = ".js-gallery-photo-rating-num"
export const PHOTO_RATING_BAR = ".js-gallery-photo-rating-bar"

export const PHOTO_COMMENT_FORM = ".js-gallery-photo-new-comment"
export const PHOTO_COMMENT_LIST = ".js-photo-gallery-comments"
export const PHOTO_COMMENT_ID = "[data-comment-id]"
export const PHOTO_COMMENT_EXAMPLE = ".js-photo-gallery-comment-example"
export const PHOTO_COMMENT_AUTHOR = ".js-photo-gallery-comment-author"
export const PHOTO_COMMENT_TEXT = ".js-photo-gallery-comment-text"

export const PHOTO_DESCRIPTION = ".js-gallery-photo-description"

export const PHOTO_HINDCAST = ".js-gallery-photo-hindcast"
export const PHOTO_TIDES = ".js-gallery-photo-tides"

export const SERVER_FORM_ERROR = "base"
